// AUTO-GENERATED — DO NOT EDIT.
// Generated from shared/models/modelRegistry.js by scripts/gen-model-registry.mjs
// (code-quality PR5). Edit the canonical source and run `npm run gen:model-registry`.
// The two copies stay byte-identical to each other — the multi-LLM zero-diff guard.

/**
 * @typedef {Object} ModelEntry
 * @property {string} id          provider-prefixed id (e.g. "anthropic/claude-opus-4-7-medium")
 * @property {string} label       user-facing display name
 * @property {string} provider    anthropic | openai | google | deepseek | openrouter | ollama |
 *                                xai | mistral | groq | qwen | kimi | zai | minimax | yi
 * @property {string} kind        text | vision | reasoning
 * @property {number} contextWindow tokens
 * @property {{ input: number, output: number }} pricing per 1M tokens, USD
 * @property {string[]} capabilities tools | vision | streaming | reasoning
 */

/** @type {ModelEntry[]} */
export const MODEL_REGISTRY = [
  // ── Anthropic ──────────────────────────────────────────────────────────
  {
    id: 'anthropic/claude-opus-5-5',
    label: 'Claude Opus 5.5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 4, output: 20 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'anthropic/claude-sonnet-5-5',
    label: 'Claude Sonnet 5.5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 2, output: 10 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'anthropic/claude-fable-5-1',
    label: 'Claude Fable 5.1',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 10, output: 50 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'anthropic/claude-opus-5',
    label: 'Claude Opus 5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 5, output: 25 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-sonnet-5',
    label: 'Claude Sonnet 5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    // 2026-08-11: Anthropic tornou o intro 2/10 PERMANENTE (10/ago), cancelando o
    // 3/15 que entraria em 01/set. Fonte: anthropic.com/news/claude-sonnet-5 + OpenRouter.
    pricing: { input: 2, output: 10 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-fable-5',
    label: 'Claude Fable 5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 10, output: 50 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  // Claude Mythos 5 exige aprovação no Project Glasswing. Ele fica disponível
  // no picker para contas aprovadas, sem substituir Fable 5 como opção geral.
  {
    id: 'anthropic/claude-mythos-5',
    label: 'Claude Mythos 5 (approved access)',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 10, output: 50 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-opus-4-8',
    label: 'Claude Opus 4.8',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 5, output: 25 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-opus-4-7-medium',
    label: 'Claude Opus 4.7 (medium)',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 5, output: 25 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-opus-4-7-fast',
    label: 'Claude Opus 4.7 (fast)',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 5, output: 25 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-sonnet-4-6',
    label: 'Claude Sonnet 4.6',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 3, output: 15 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'anthropic/claude-haiku-4-5',
    label: 'Claude Haiku 4.5',
    provider: 'anthropic',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 1, output: 5 },
    capabilities: ['tools', 'streaming'],
  },
  // ── OpenAI ─────────────────────────────────────────────────────────────
  {
    id: 'openai/gpt-5',
    label: 'GPT-5',
    provider: 'openai',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 5, output: 20 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'openai/gpt-5-mini',
    label: 'GPT-5 mini',
    provider: 'openai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.5, output: 2 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'openai/gpt-5.5',
    label: 'GPT-5.5',
    provider: 'openai',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 5, output: 20 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'openai/gpt-5.5-pro',
    label: 'GPT-5.5 Pro',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 200_000,
    pricing: { input: 15, output: 60 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.5-thinking',
    label: 'GPT-5.5 Thinking',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 200_000,
    pricing: { input: 10, output: 40 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.5-instant',
    label: 'GPT-5.5 Instant',
    provider: 'openai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 1, output: 4 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'openai/o4',
    label: 'OpenAI o4 (reasoning)',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 200_000,
    pricing: { input: 15, output: 60 },
    capabilities: ['reasoning', 'streaming'],
  },
  // GPT-5.6 family (GA jul/2026, developers.openai.com/api/docs/models).
  // gpt-5.6 alias → gpt-5.6-sol. Apolo usa chat/completions (Responses-only
  // *-pro variants omitidos). contextWindow 1.05M (família gpt-5.6).
  {
    id: 'openai/gpt-5.6-sol',
    label: 'GPT-5.6 Sol',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 5, output: 30 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.6-terra',
    label: 'GPT-5.6 Terra',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 2, output: 12 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.6-luna',
    label: 'GPT-5.6 Luna',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 0.2, output: 1.2 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  // GPT-5.4 family — reasoning c/ effort (none…max);
  // the speed selector maps to `reasoning_effort`. contextWindow 400K.
  {
    id: 'openai/gpt-5.4',
    label: 'GPT-5.4',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 400_000,
    pricing: { input: 2.5, output: 15 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.4-mini',
    label: 'GPT-5.4 Mini',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 400_000,
    pricing: { input: 1, output: 6 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-5.4-nano',
    label: 'GPT-5.4 Nano',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 400_000,
    pricing: { input: 0.5, output: 3 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  // GPT-6 family (OpenAI API, Sep/2026). `gpt-6-sol` is the balanced
  // general-purpose model; Astra and Luna cover frontier and high-volume use.
  {
    id: 'openai/gpt-6-astra',
    label: 'GPT-6 Astra',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 10, output: 50 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-6-sol',
    label: 'GPT-6 Sol',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 2, output: 10 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'openai/gpt-6-luna',
    label: 'GPT-6 Luna',
    provider: 'openai',
    kind: 'reasoning',
    contextWindow: 1_050_000,
    pricing: { input: 0.1, output: 0.5 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },

  // ── Google ─────────────────────────────────────────────────────────────
  {
    id: 'google/gemini-3.6-flash',
    label: 'Gemini 3.6 Flash',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    // 2026-08-11: correção de erro de 10× (era 0.15/0.6). Preço real 1.50/7.50.
    // Fonte: openrouter.ai/google/gemini-3.6-flash + ai.google.dev/gemini-api/docs/pricing.
    pricing: { input: 1.5, output: 7.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'google/gemini-3.5-flash-lite',
    label: 'Gemini 3.5 Flash-Lite',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.3, output: 2.5 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'google/gemini-2.5-pro',
    label: 'Gemini 2.5 Pro',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 1.25, output: 5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'google/gemini-2.5-flash',
    label: 'Gemini 2.5 Flash',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.075, output: 0.3 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'google/gemini-3.1-pro-preview',
    label: 'Gemini 3.1 Pro',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 2.5, output: 10 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'google/gemini-3-flash-preview',
    label: 'Gemini 3 Flash',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.15, output: 0.6 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'google/gemini-3.1-flash-lite',
    label: 'Gemini 3.1 Flash-Lite',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.05, output: 0.2 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'google/gemini-3.5-flash',
    label: 'Gemini 3.5 Flash',
    provider: 'google',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 1.5, output: 9 },
    capabilities: ['tools', 'vision', 'streaming'],
  },

  // ── DeepSeek ───────────────────────────────────────────────────────────
  // A API oficial agora recomenda `deepseek-flash` (V4.1 Flash). O anterior
  // `deepseek-v4-flash` continua listado como compatibilidade para sessões já
  // salvas e é encaminhado pelo provider ao Flash atual.
  {
    id: 'deepseek/deepseek-flash',
    label: 'DeepSeek V4.1 Flash',
    provider: 'deepseek',
    kind: 'reasoning',
    contextWindow: 1_048_576,
    pricing: { input: 0.14, output: 0.28 },
    capabilities: ['tools', 'vision', 'reasoning', 'streaming'],
  },
  {
    id: 'deepseek/deepseek-v4-pro',
    label: 'DeepSeek V4 Pro',
    provider: 'deepseek',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.435, output: 0.87 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'deepseek/deepseek-v4-flash',
    label: 'DeepSeek V4 Flash',
    provider: 'deepseek',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.14, output: 0.28 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },

  // ── OpenRouter (catch-all, 200+ models) ────────────────────────────────
  {
    id: 'openrouter/auto',
    label: 'OpenRouter Auto',
    provider: 'openrouter',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0, output: 0 }, // routed dynamically
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'openrouter/nex-agi/nex-n2-pro:free',
    label: 'Nex-N2-Pro (free)',
    provider: 'openrouter',
    kind: 'text',
    contextWindow: 262_144,
    pricing: { input: 0, output: 0 }, // free tier
    capabilities: ['tools', 'reasoning', 'streaming'],
  },

  // ── xAI / Grok ─────────────────────────────────────────────────────────
  {
    id: 'xai/grok-4.5',
    label: 'Grok 4.5',
    provider: 'xai',
    kind: 'text',
    contextWindow: 500_000,
    pricing: { input: 2, output: 6 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'xai/grok-4.3',
    label: 'Grok 4.3',
    provider: 'xai',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 1.25, output: 2.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'xai/grok-4',
    label: 'Grok 4',
    provider: 'xai',
    kind: 'text',
    contextWindow: 256_000,
    pricing: { input: 1.25, output: 2.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'xai/grok-4-fast',
    label: 'Grok 4 Fast',
    provider: 'xai',
    kind: 'text',
    contextWindow: 256_000,
    pricing: { input: 0.4, output: 1.5 },
    capabilities: ['tools', 'streaming'],
  },

  // ── Mistral ────────────────────────────────────────────────────────────
  {
    id: 'mistral/mistral-medium-3-5',
    label: 'Mistral Medium 3.5',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.4, output: 2.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'mistral/mistral-small-2603',
    label: 'Mistral Small 4',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.15, output: 0.6 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'mistral/mistral-large-3',
    label: 'Mistral Large 3',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.5, output: 1.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'mistral/mistral-medium-3',
    label: 'Mistral Medium 3',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.4, output: 2.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'mistral/mistral-small-4',
    label: 'Mistral Small 4',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.15, output: 0.6 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'mistral/codestral',
    label: 'Codestral',
    provider: 'mistral',
    kind: 'text',
    contextWindow: 256_000,
    pricing: { input: 0.3, output: 0.9 },
    capabilities: ['tools', 'streaming'],
  },

  // ── Groq (hosted, sub-second inference) ────────────────────────────────
  // ids = nome REAL da API do Groq (confirmado via console.groq.com/docs/models
  // em 2026-08). O Worker compat faz stripProviderPrefix(model) (1º "/").
  {
    id: 'groq/groq/compound',
    label: 'Groq Compound',
    provider: 'groq',
    kind: 'text',
    contextWindow: 131_072,
    pricing: { input: 0, output: 0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'groq/llama-3.3-70b-versatile',
    label: 'Llama 3.3 70B (Groq)',
    provider: 'groq',
    kind: 'text',
    contextWindow: 131_072,
    pricing: { input: 0.59, output: 0.79 },
    capabilities: ['tools', 'streaming'],
  },

  // ── Qwen / Alibaba ─────────────────────────────────────────────────────
  {
    id: 'qwen/qwen3.7-max',
    label: 'Qwen3.7 Max',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 2.5, output: 7.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'qwen/qwen3-coder-plus',
    label: 'Qwen3 Coder Plus',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.65, output: 3.25 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'qwen/qwen3.7-plus',
    label: 'Qwen3.7 Plus',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.4, output: 1.2 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'qwen/qwen3.7-flash',
    label: 'Qwen3.7 Flash',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.05, output: 0.4 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'qwen/qwen3-coder-flash',
    label: 'Qwen3 Coder Flash',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.1, output: 0.4 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'qwen/qwen3-vl-max',
    label: 'Qwen3-VL Max',
    provider: 'qwen',
    kind: 'text',
    contextWindow: 262_144,
    pricing: { input: 0.8, output: 2.4 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'qwen/qwq-max',
    label: 'QwQ Max (reasoning)',
    provider: 'qwen',
    kind: 'reasoning',
    contextWindow: 262_144,
    pricing: { input: 0.8, output: 2.4 },
    capabilities: ['reasoning', 'streaming'],
  },

  // ── Kimi / Moonshot ────────────────────────────────────────────────────
  {
    id: 'kimi/kimi-k3',
    label: 'Kimi K3',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 1_000_000,
    // 2026-08-11: correção (era 0.8/3.0). Preço oficial Moonshot 3/15 (uncached);
    // o adapter bate direto em api.moonshot.ai. Fonte: platform.moonshot.ai + OpenRouter (2.80/14).
    pricing: { input: 3.0, output: 15.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'kimi/kimi-k2.7-code',
    label: 'Kimi K2.7 Code',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 260_000,
    pricing: { input: 0.95, output: 4.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/kimi-k2.7-code-highspeed',
    label: 'Kimi K2.7 Code (High-Speed)',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 260_000,
    pricing: { input: 1.9, output: 8.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/kimi-k2.6',
    label: 'Kimi K2.6',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 260_000,
    pricing: { input: 0.6, output: 2.5 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/kimi-k2.5',
    label: 'Kimi K2.5',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 0.5, output: 2.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-8k',
    label: 'Moonshot v1 8K',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 8_000,
    pricing: { input: 0.2, output: 2.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-32k',
    label: 'Moonshot v1 32K',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 32_000,
    pricing: { input: 1.0, output: 3.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-128k',
    label: 'Moonshot v1 128K',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 2.0, output: 5.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-8k-vision-preview',
    label: 'Moonshot v1 8K Vision',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 8_000,
    pricing: { input: 0.2, output: 2.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-32k-vision-preview',
    label: 'Moonshot v1 32K Vision',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 32_000,
    pricing: { input: 1.0, output: 3.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'kimi/moonshot-v1-128k-vision-preview',
    label: 'Moonshot v1 128K Vision',
    provider: 'kimi',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 2.0, output: 5.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },

  // ── Z.ai / GLM ─────────────────────────────────────────────────────────
  {
    id: 'zai/glm-5.3',
    label: 'GLM 5.3',
    provider: 'zai',
    kind: 'text',
    contextWindow: 1_000_000,
    // docs.z.ai/guides/llm/glm-5.3 (ago/2026): $1.40 in / $4.40 out per 1M.
    // Thinking always-on; reasoning_effort low|high|max (default max).
    pricing: { input: 1.4, output: 4.4 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-5.2',
    label: 'GLM 5.2',
    provider: 'zai',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 0.8, output: 3.0 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-5.1',
    label: 'GLM 5.1',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.8, output: 3.0 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-5',
    label: 'GLM 5',
    provider: 'zai',
    kind: 'text',
    contextWindow: 200_000,
    pricing: { input: 0.6, output: 2.2 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-5-turbo',
    label: 'GLM 5 Turbo',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.4, output: 1.5 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'zai/glm-4.7',
    label: 'GLM 4.7',
    provider: 'zai',
    kind: 'text',
    contextWindow: 202_752,
    pricing: { input: 0.4, output: 1.75 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-4.7-flash',
    label: 'GLM 4.7 Flash',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.07, output: 0.28 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'zai/glm-4.5-air',
    label: 'GLM 4.5 Air',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.07, output: 0.28 },
    capabilities: ['tools', 'reasoning', 'streaming'],
  },
  {
    id: 'zai/glm-4-32b-0414',
    label: 'GLM 4 32B 128K',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.3, output: 1.0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'zai/glm-5v-turbo',
    label: 'GLM 5V Turbo',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.5, output: 2.0 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'zai/glm-4.6v',
    label: 'GLM 4.6V',
    provider: 'zai',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.4, output: 1.5 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'zai/glm-ocr',
    label: 'GLM OCR',
    provider: 'zai',
    kind: 'text',
    contextWindow: 32_000,
    pricing: { input: 0.05, output: 0.1 },
    capabilities: ['vision', 'streaming'],
  },
  {
    id: 'minimax/minimax-m3',
    label: 'MiniMax M3',
    provider: 'minimax',
    kind: 'text',
    contextWindow: 1_000_000,
    pricing: { input: 0.6, output: 2.4 },
    capabilities: ['tools', 'vision', 'streaming'],
  },
  {
    id: 'minimax/minimax-m2.7',
    label: 'MiniMax M2.7',
    provider: 'minimax',
    kind: 'text',
    contextWindow: 205_000,
    pricing: { input: 0.3, output: 1.2 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'minimax/minimax-m2.7-highspeed',
    label: 'MiniMax M2.7 Highspeed',
    provider: 'minimax',
    kind: 'text',
    contextWindow: 205_000,
    pricing: { input: 0.6, output: 2.4 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'minimax/minimax-m2.5',
    label: 'MiniMax M2.5',
    provider: 'minimax',
    kind: 'text',
    contextWindow: 205_000,
    pricing: { input: 0.15, output: 1.15 },
    capabilities: ['tools', 'streaming'],
  },

  // ── Yi / 01.ai ─────────────────────────────────────────────────────────
  {
    id: 'yi/yi-lightning',
    label: 'Yi Lightning',
    provider: 'yi',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.15, output: 0.5 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'yi/yi-large',
    label: 'Yi Large',
    provider: 'yi',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0.3, output: 0.9 },
    capabilities: ['tools', 'streaming'],
  },

  // ── Ollama (local) ─────────────────────────────────────────────────────
  {
    id: 'ollama/llama-3.3-70b',
    label: 'Llama 3.3 70B (local)',
    provider: 'ollama',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0, output: 0 },
    capabilities: ['tools', 'streaming'],
  },
  {
    id: 'ollama/deepseek-r1-32b',
    label: 'DeepSeek R1 32B (local)',
    provider: 'ollama',
    kind: 'reasoning',
    contextWindow: 128_000,
    pricing: { input: 0, output: 0 },
    capabilities: ['reasoning', 'streaming'],
  },
  {
    id: 'ollama/qwen-2.5-coder-32b',
    label: 'Qwen 2.5 Coder 32B (local)',
    provider: 'ollama',
    kind: 'text',
    contextWindow: 128_000,
    pricing: { input: 0, output: 0 },
    capabilities: ['tools', 'streaming'],
  },
];

/** Look up an entry by id. Returns undefined when not found. */
export function findModel(modelId) {
  if (typeof modelId !== 'string') return undefined;
  return MODEL_REGISTRY.find((m) => m.id === modelId);
}

/** Group entries by provider. Used by the model picker UI. */
export function groupByProvider() {
  return MODEL_REGISTRY.reduce((acc, m) => {
    if (!acc[m.provider]) acc[m.provider] = [];
    acc[m.provider].push(m);
    return acc;
  }, {});
}

/** Lowercased provider name for the entry, e.g. 'anthropic'. */
export function providerOf(modelId) {
  return findModel(modelId)?.provider;
}
